<template>
  <card>
    <vue-element-loading
      :text="loading.text"
      spinner="bar-fade-scale"
      :color="loading.color"
      :active="loading.active"
      :is-full-screen="false"/>
    <div slot="header">
      <h4 class="title">Nuevo Identificador</h4>
    </div>
    <div>
      <form id="edit_form">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nombre"
                      placeholder="Nombre del Identificador"
                      v-model="device.identifier"
                      v-validate="modelValidations.name"
                      name="name"
                      :error="getError('name')"
            >
            </fg-input>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
            Agregar Identificador
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
  import vueElementLoading from 'vue-element-loading'
  import swal from 'sweetalert2'
  import {Dialog, Option, Select} from 'element-ui'

  export default {
    components: {
      vueElementLoading,
      swal,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        users: [],
        loadingUsers: false,
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        device: {
          identifier: '',
        },
        account: {},
        modelValidations: {
          name: {
            required: true
          },
          country: {
            required: true,
          }
        }
      }
    },
    mounted() {
    },
    methods: {
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid)
            this.addDevice();
        })
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      addDevice() {
        this.loading.active = true
        this.axios({
          url: `conexions.php`,
          method: 'post',
          data: this.device,
          headers: {
            authorization: localStorage.token
          }
        })
          .then(response => {
            this.loading.active = false
            this.showSwal('success', 'Identificador Creado')
            this.clearModel()
          })
          .catch(error => {
            console.log(error.response)
            this.loading.active = false
            this.showSwal('error', error.response.data.message)
          })
      },
      showSwal(type, message) {
        if (type === 'success') {
          swal.fire({
            title: message,
            type: 'success'
          })
        } else if (type === 'error') {
          swal.fire({
            title: message,
            type: 'warning'
          })
        }
      },
      clearModel() {
        this.device = {
          identifier: '',
        }
      }
    }
  }

</script>
<style>
  #edit_form label {
    color: #777 !important;
  }

  option {
    background-color: red !important;
  }
</style>
